import React from 'react';
import PropTypes from 'prop-types';
import './progress-bar.style.scss';

/**
 * Variable representing the progress bar component.
 * @param {object} props - The component props.
 * @return {object} jsx - The jsx component.
 * */
const ProgressBar = ({ width }) => (
  <div className="audio-progress">
    <div className="bar" style={{ width }} />
  </div>
);

export default ProgressBar;

ProgressBar.propTypes = {
  width: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/common/components/progress-bar/progress-bar.component.js